import { animate, style, transition, trigger } from '@angular/animations';

export const scrollInUp = trigger('scrollInUp', [
  transition(':enter', [
    style({ transform: 'translateY(100%)', opacity: 0 }),
    animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [animate('400ms ease-out', style({ opacity: 0, transform: 'translateY(-100%)' }))]),
]);

export const fadeInUp = trigger('scrollInUp', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(100%)',
    }),
    animate(
      '400ms cubic-bezier(0.4,0,0.2,1)',
      style({
        opacity: 1,
        transform: 'translateY(0)',
      })
    ),
  ]),
]);

export const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'scale(0.95) translateZ(0)',
    }),
    animate(
      '200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
      style({
        opacity: 1,
        transform: 'scale(1) translateZ(0)',
      })
    ),
  ]),
  transition(':leave', [
    animate(
      '150ms cubic-bezier(0.4, 0.0, 1, 1)',
      style({
        opacity: 0,
        transform: 'scale(0.95) translateZ(0)',
      })
    ),
  ]),
]);
